/* eslint-disable no-nested-ternary */
import { isEmpty } from 'lodash'
import { HistoryAction } from './HistoryAction'
import { HistoryActionType } from './HistoryActionType'
import { patchAssetById } from '~/actions/layer'
import { setIOPointsData } from '~/actions/preview'

export class IOPointsHistoryAction extends HistoryAction {

  constructor(payload, ...params) {
    super(HistoryActionType.IOPointsHistoryAction, payload, ...params)
    const {
      prevIOPoints,
      nextIOPoints,
      prevShowInOutPoints,
      nextShowInOutPoints,
      nextPreviewAssetProps,
      prevPreviewAssetProps,
      assetId,
    } = payload?.historyProperties ?? {}
    this._prevIOPoints = prevIOPoints
    this._nextIOPoints = nextIOPoints
    this._prevShowInOutPoints = prevShowInOutPoints
    this._nextShowInOutPoints = nextShowInOutPoints
    this._prevPreviewAssetProps = prevPreviewAssetProps
    this._nextPreviewAssetProps = nextPreviewAssetProps
    this._assetId = assetId
  }

  get assetId() {
    return this._assetId
  }

  get prevIOPoints() {
    return this._prevIOPoints
  }

  get nextIOPoints() {
    return this._nextIOPoints
  }

  get prevShowInOutPoints() {
    return this._prevShowInOutPoints
  }

  get nextShowInOutPoints() {
    return this._nextShowInOutPoints
  }

  get prevPreviewAssetProps() {
    return this._prevPreviewAssetProps
  }

  get nextPreviewAssetProps() {
    return this._nextPreviewAssetProps
  }

  * undo() {
    const { prevIOPoints, prevShowInOutPoints, prevPreviewAssetProps, assetId } = this
    if (!isEmpty(prevIOPoints)) {
      yield setIOPointsData(prevIOPoints, prevShowInOutPoints)
    }
    if (!isEmpty(prevPreviewAssetProps)) {
      yield patchAssetById(assetId, prevPreviewAssetProps)
    }
  }

  * redo() {
    const { nextIOPoints, nextShowInOutPoints, nextPreviewAssetProps, assetId } = this

    if (!isEmpty(nextIOPoints)) {
      yield setIOPointsData(nextIOPoints, nextShowInOutPoints)
    }
    if (!isEmpty(nextPreviewAssetProps)) {
      yield patchAssetById(assetId, nextPreviewAssetProps)
    }
  }

}
